/**
 * StoreController.java 对应的 model
 */

import Model from './model'
// import { SetsConst } from 'core/constant'
const model = new Model()
class Store {
    /**
     * 使用 ajax 方式获取商店资源信息 IndexController.storeResource
     * @param params request 参数
     * @returns {*}
     */
    static getStoreResource(params) {
        return model.get('/store/open/resourceInfo', params)
    }

    static getQuestionsByFilter(params) {
        return model.post('/store/getQuestions', params)
    }
}
export default Store



// WEBPACK FOOTER //
// ./bootsets/models/store.js